<div class="root-error">
  <img
    [ngClass]="{
      'image--placeholder': env.isWhiteLabel,
    }"
    class="image"
    role="presentation"
    alt=""
    src="./assets/images/error_page.jpg"
  />
  @if (displayedText.title) {
    <h1 id="infosTitle">{{ infos?.title }}</h1>
  }

  @if (displayedText.summary) {
    <p id="infosSummary">{{ infos?.summary }}</p>
  }

  @if (infos?.details && displayedText.details) {
    <p id="infosDetails">
      {{ infos?.details }}
    </p>
  }

  @if (goBackUri) {
    @if (displayedText.additionnalText) {
      <p id="infosAddtionnalText">
        {{ displayedText.additionnalText | translate }}
      </p>
    }
    <!-- Prevent giving too much information such as contact support email in case users arrive on this page without context (= redirectUri) -->
    <!-- But remain on this page rather than redirecting to royalcanin.com as it is done on other pages -->
    <!-- This is better UX, for instance if an error occurred during social login and context is lost, at least users understand something went wrong -->
    @if (displayedText.contactSupport) {
      <p id="infosContactSupport">
        <app-contact-us-button
          id="rootErrorContactSupportLink"
          labelKey="contactSupportPage_title"
        ></app-contact-us-button>
      </p>
    }
    @if (displayedText.goBack) {
      <p id="infosGoBack">
        <a id="go-back" (click)="goBack()" class="rc-link">{{
          'registerApp_errorPageContinue' | translate
        }}</a>
      </p>
    }
  }
</div>
